import { render, staticRenderFns } from "./GuardIsProtected.vue?vue&type=template&id=098046cc"
import script from "./GuardIsProtected.vue?vue&type=script&lang=js"
export * from "./GuardIsProtected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports